// extracted by mini-css-extract-plugin
export var hideEditor = "_s9-2";
export var infoIcon = "_s9-3";
export var label = "_s9-1";
export var labelContainer = "_s9-0";
export var readonlyText = "_s9-4";